import { QuoteDataProvider } from '../context/QuotesContext';
import { CustomerDataProvider } from '../../customers/context/CustomersContext';
import CreateQuote from './CreateQuote';
import { ServicesDataProvider } from '../../services/context';

/**
 * QuotesDetailPage
 *
 * This component serves as the detail page for a single quote, typically rendered at the route `/quotes/:id`.
 * It wraps the `QuoteDetail` component with the `QuoteDataProvider` context, ensuring that all quote-related
 * data and actions are available to `QuoteDetail` and its children. This pattern allows for context-driven
 * state management and data fetching, and ensures the detail view is always in sync with the latest quote data.
 *
 * Usage:
 *   <Route path="/quotes/:id" element={<QuotesDetailPage />} />
 *
 * Context:
 *   - Provides quote data and actions via QuoteDataProvider
 *   - Used by QuoteDetail to display and manage a single quote
 */
export default function QuotesDetailPage() {
  return (
    <CustomerDataProvider>
      <ServicesDataProvider>
        <QuoteDataProvider>
          <CreateQuote />
        </QuoteDataProvider>
      </ServicesDataProvider>
    </CustomerDataProvider>
  );
}
